<template>
	<img :src="currentSrc" :alt="alt" @error="onError" />
</template>

<script setup>
import { ref, watch } from 'vue';

const assetsUrl = (relativePath) => {
	return `${import.meta.env.VITE_BASE_URL}/${relativePath}`;
};

const props = defineProps({
	src: String,
	alt: {
		type: String,
		default: '',
	},
	fallback: {
		type: String,
		default: '/media/icons/logo-gray.svg', // Path to your fallback image
	},
});

const currentSrc = ref(props.src);

watch(
	() => props.src,
	(newSrc) => {
		currentSrc.value = newSrc || assetsUrl(props.fallback);
	}
);

function onError() {
	currentSrc.value = assetsUrl(props.fallback);
}
</script>

<style scoped>
/* Add your styles here */
</style>
